import { render, staticRenderFns } from "./schedule-invoice-body.vue?vue&type=template&id=15f0aff0&"
import script from "./schedule-invoice-body.vue?vue&type=script&lang=js&"
export * from "./schedule-invoice-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports